import React from 'react';

import { Modal } from 'antd';
import PropTypes from 'prop-types';

import Editor from '~/components/Editor';

function VisualizarTemplate({ template, title, visible, onCancel, onOk }) {
  return (
    <>
      <Modal
        title={title}
        visible={visible}
        width={900}
        okText="Selecionar template"
        onOk={onOk}
        onCancel={onCancel}
      >
        <Editor content={template} height="calc(100vh - 18rem)" disabled readOnly />
      </Modal>
    </>
  );
}

VisualizarTemplate.defaultProps = {
  template: '',
  title: '',
  visible: false,
  onCancel: () => null,
  onOk: () => null,
};

VisualizarTemplate.propTypes = {
  template: PropTypes.string,
  title: PropTypes.string,
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
};

export default VisualizarTemplate;
